import React from "react";
import { LongTextLabel } from "@sscs/ui";
import GroupAvatar from "../../assets/AddGroupNoCamera.svg";
import styles from "./groupName.module.scss";

type GroupNameProps = {
  name: string;
  isDefault: boolean;
};

const GroupName = ({ name, isDefault }: GroupNameProps): React.JSX.Element => {
  return (
    <div className={styles.root}>
      <GroupAvatar className={styles["group-avatar"]} />
      <div>
        <LongTextLabel label={name} className={styles["name-label"]} />
        {isDefault && (
          <div className={styles["default-group"]}>(Default group)</div>
        )}
      </div>
    </div>
  );
};

export default GroupName;
